var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNpxs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32928)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#F5D100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98425 2.25C5.27175 2.25 2.25 5.27175 2.25 8.98425C2.25 12.6967 5.27175 15.7241 8.98988 15.7241C12.7074 15.7241 15.7292 12.7024 15.7292 8.98425C15.7292 5.26669 12.7018 2.25 8.98425 2.25ZM8.98425 15.2044C5.5575 15.2044 2.76412 12.4166 2.76412 8.98425C2.76975 5.5575 5.5575 2.76919 8.98425 2.76919C12.4116 2.76919 15.2049 5.5575 15.2049 8.98988C15.2049 12.4166 12.4166 15.2044 8.98425 15.2044Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.49786 5.9941L5.99286 5.49854L8.62986 8.13497L8.1343 8.62997L5.49786 5.9941ZM9.33299 9.83091L9.82855 9.33535L12.465 11.9718L11.9694 12.4668L9.33299 9.83091ZM8.49205 8.98604L8.98705 8.49104L9.48655 8.98941L8.99155 9.48554L8.49205 8.98604ZM9.3403 8.15635L11.9767 5.52047L12.4717 6.01604L9.83586 8.65247L9.3403 8.15635ZM5.51699 11.9746L8.15286 9.33872L8.64843 9.83372L6.01255 12.4702L5.51699 11.9746Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32928"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNpxs);
export default __webpack_public_path__ + "static/media/npxs.1230adb3f6dc26555f24b193100899d4.svg";
export { ForwardRef as ReactComponent };